module.exports = __webpack_public_path__ + "img/gradient-bg.ca579877.jpg";